module.exports = __webpack_public_path__ + "media/images/icons/icon_pageType_01-7647045a8554011f21b0cd1264877b03.svg";